import { autoinject, transient, computedFrom, useView } from "aurelia-framework";
import { VesselDetailModel, GetBannerResponse, RatingsSummaryModel, GetVesselDynamicPropertiesResponse } from "../../../../../../models/vessels/vessel.models";
import { UserClaimsService } from "../../../../../../services/authentication/user-claims.service";
import { Claims } from "../../../../../../constants/authentication/claims";
import { RightShipQiRouterConstants } from "../../../../../../configuration/rightshipqi-router.constants";
import { Router } from "aurelia-router";
import * as moment from "moment";
import { RightShipDialogServiceConstants } from "../../../../../../constants/basics/rightship-dialog.constants";
import { DialogClientService } from "@rightship-tech/common-ui/services/basic/dialog-client.service";
import { MdrProperty } from "../../../../../../models/data-steward/data-steward.models";
import { DataType } from "../../../../../../models/queries/queries.models";
import * as Enumerable from "linq";
import { CompSafetyScore } from "@rightship-tech/common-ui/components/comp-safety-score/comp-safety-score";
import { ManageVesselService } from "../../../../../../services/vessels/manage-vessel.service";
import { StringUtilities } from "../../../../../../utilities/strings";
import { LookupValue } from "../../../../../../models/lookups/lookup.models";
import { ConfigService } from "@rightship-tech/common-ui/services/basic/config.service";

@autoinject
@transient()
@useView('views/pages/modules/vessels/steps/vessel-details-tabs/vessel-details-details.html')
export class VesselDetailsDetails {

    private _searchFilter: string;

    public properties: { [section: string]: { title: string, value: string, isClass: boolean }[] } = {};
    public vessel: VesselDetailModel;
    public ratingModel: RatingsSummaryModel;
    public canEditVesselDetails: boolean;
    public canViewVesselDetails: boolean;
    public canEditExemptRightShipInspectionUntil: boolean;
    public banners: GetBannerResponse[] = [];
    public searchSections: string[];
    public isMenuVisible: () => boolean;
    public canReportIssue: boolean;
    public canExportVesselDetails: boolean;
    public openSubmitDialog: boolean;
    private vesselManagedEntityResponse: GetVesselDynamicPropertiesResponse;
    private usedManageEntityGroups: LookupValue[];@computedFrom('vessel', 'vessel.keelLaidDateConvertedDate')
    public get keelLaidDate(): string {
        if (this.vessel["keelLaidDateConvertedDate"] == null)
            return "";
        return moment.utc(this.vessel["keelLaidDateConvertedDate"]).format(this.configService.config.common.defaultDateFormat);
    }

    public set searchFilter(value: string) {
        const properties = [];
        if (value != null) {
            [].slice.call(this.element.querySelectorAll('collapsable .section-info')).forEach(c => {
                const labelElement = c.querySelector('.label');
                if (labelElement) {
                    const hasTooltip = labelElement.className ? labelElement.className.includes('has-tooltip') : false;
                    let tooltipInfo = "";
                    let label = "";
                    if (hasTooltip) {
                        label = labelElement.querySelector('.inner-label').textContent;
                        tooltipInfo = labelElement.querySelector('.comp-tooltip--content').textContent;
                    }
                    else {
                        label = labelElement.textContent;
                    }
                    if (label.toLowerCase().indexOf(value.toLowerCase()) > -1) {

                        if (properties.some(c => c.title == label)) {
                            return;
                        }

                        let element = c.querySelector('.value .display-value');
                        if (!element) {
                            element = c.querySelector('.value');
                        }
                        if (element) {
                            let propertyName;
                            const editableProp: HTMLElement = $(element).closest('.editable-entity-property').get(0);
                            if (editableProp) {
                                propertyName = editableProp.getAttribute('data-name');
                            }
                            const isClass = labelElement.classList.contains('is-class');
                            const section = $(c).closest("collapsable").get(0).querySelector('.collapsable--header-title').textContent;
                            properties.push({
                                title: label,
                                value: element.textContent,
                                tab: "Vessel Details",
                                section: section,
                                isClass: isClass,
                                name: propertyName,
                                hasTooltip: hasTooltip,
                                tooltipInfo: tooltipInfo
                            });
                        } else {
                            console.log("Element not found for label : " + label);
                        }
                    }
                }
            });

            [].slice.call(this.element.querySelectorAll('.role')).forEach(c => {
                const labelElement = c.querySelector('.role-name');
                if (labelElement) {
                    const label = labelElement.textContent;
                    if (label.toLowerCase().indexOf(value.toLowerCase()) > -1) {

                        if (properties.some(c => c.title == label)) {
                            return;
                        }

                        let element = c.querySelector('.value .display-value');
                        if (!element) {
                            element = c.querySelector('.value');
                        }
                        if (element) {
                            properties.push({
                                title: label,
                                value: element.textContent,
                                tab: "Vessel Details",
                                section: "Vessel Details"
                            });
                        } else {
                            console.log("Element not found for label : " + label);
                        }
                    }
                }
            });

            this.vesselManagedEntityResponse.dynamicPropertiesResponse.entityDynamicValues.forEach(dynamicValue => {

                const dynamicColumn = this.vesselManagedEntityResponse.dynamicPropertiesResponse.dynamicColumns.filter(x => x.columnId == dynamicValue.columnId)[0];

                const manageEntityGroupId = dynamicColumn.manageEntityGroupId;
                const displayName = dynamicColumn.displayName;
                const section = this.usedManageEntityGroups.filter(c => c.id == manageEntityGroupId)[0];
                const sectionName = section != null ? section.name : "Misc";

                if (displayName && displayName.toLowerCase().indexOf(value.toLowerCase()) > -1) {
                    properties.push({
                        title: displayName,
                        value: dynamicValue.value,
                        tab: "Vessel attributes",
                        section: sectionName
                    });
                }
                
                this.properties = {};
                Enumerable.from(properties).groupBy(c => c.tab).forEach(group => {
                    group.groupBy(c => c.section).forEach(section => {
                        this.properties[group.key() + " - " + section.key()] = section.toArray();
                    });
                });
                this.searchSections = Object.keys(this.properties);
                this._searchFilter = value;
            });
        }
    }

    @computedFrom('_searchFilter')
    public get searchFilter(): string {
        return this._searchFilter;
    }

    @computedFrom('vessel')
    public get maximumSpeedAfterEplDisplayValue(): string {
        return this.vessel.maximumSpeedAfterEpl ?
            ((this.vessel.maximumSpeedAfterEpl * 0.98).toFixed(2) + "~" + (this.vessel.maximumSpeedAfterEpl * 1.02).toFixed(2)) : 'N/A';
    }

    @computedFrom('vessel')
    public get speedMaxDisplayValue(): string {
        return this.vessel.speedMax ?
            ((this.vessel.speedMax * 0.98).toFixed(2) + "~" + (this.vessel.speedMax * 1.02).toFixed(2)) : 'N/A';
    }

    public constructor(userClaimsService: UserClaimsService,
        private dialogService: DialogClientService,
        private element: Element,
        private router: Router,
        private manageVesselService: ManageVesselService,
        private configService: ConfigService) {
        this.canEditVesselDetails = userClaimsService.hasPermission(Claims.EditVesselDetails);
        this.canViewVesselDetails = this.canEditVesselDetails || userClaimsService.hasPermission(Claims.CanViewVesselDetailsEdits);
        this.canEditExemptRightShipInspectionUntil = userClaimsService.hasPermission(Claims.CanEditExemptRightShipInspectionUntil);
        this.canReportIssue = userClaimsService.hasPermission(Claims.CanSubmitDataAboutVessel);
        this.canExportVesselDetails = userClaimsService.hasPermission(Claims.CanExportVesselDetails);
        this.openSubmitDialog = (this.configService.config.environment &&
            (this.configService.config.environment.toLowerCase() == "production" || this.configService.config.environment.toLowerCase() == "staging"));
    }

    activate(model: { vessel: VesselDetailModel }) {
        this.vessel = model.vessel;

        this.manageVesselService.getVesselDynamicProperties(this.vessel.vesselId).then(x => {                
            this.vesselManagedEntityResponse = x;

            const groupIds = x.dynamicPropertiesResponse.dynamicColumns.map(x => x.manageEntityGroupId);
            this.usedManageEntityGroups = x.manageEntityGroups.filter(x => groupIds.filter(y => y == x.id).length > 0);
        });
    }

    requestRightShipInspection(type: number) {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.RequiresRightshipInspectionDialog, {
            vesselName: this.vessel.name,
            imo: this.vessel.internationalMaritimeOrganizationNumber ? this.vessel.internationalMaritimeOrganizationNumber :
                this.vessel.europeanNumberOfIdentification ? this.vessel.europeanNumberOfIdentification :
                    this.vessel.vehicleIdentificationNumber ? this.vessel.vehicleIdentificationNumber : "",
            type: type,
            vesselId: this.vessel.vesselId,
            id: 0
        }, true, true, false, "right");
    }

    openRolesDefinitionDialog() {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.RolesDefinitionDialog, false, true, false, false);
    }

    addInspection(inspectionType) {
        this.router.navigateToRoute(RightShipQiRouterConstants.RouteNames.AddRightShipInspection, {
            id: 0,
            inspectionTypeId: inspectionType
        });
        //pass the vessel through histry instead of url
        this.router.history.setState("vessel", this.vessel);
    }

    editVesselClasses() {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.EditVesselClassesDialog, {
            vessel: this.vessel
        }, true, false, false, "right");
    }

    getListFromString(listString: string, delimeter: string = ";") {
        if (!listString || listString == null) return listString;
        //replace , in number example 1,500 so that it is not split
        const list = listString.replace(/(\d),(\d)/g, '$1{{comma}}$2').split(delimeter);

        const formattedList = list.map(x => `<span class="row">${x}</span>`);

        return formattedList.join("").replace(/{{comma}}/g, ",");
    }

    roleValueAction(companyId: number) {
        if (companyId && companyId > 0 && this.router.routes.map(x => x.name).indexOf(RightShipQiRouterConstants.RouteNames.Company) > -1)
            return this.router.generate(RightShipQiRouterConstants.RouteNames.Company, { id: companyId });

        return null;
    }

    getOverriddenValuesForDateOfBuild(propertyName: string, overriddenValue: any, sourceComment: string) {
        return [
            { propertyName: propertyName, overriddenValue: moment(overriddenValue).format("YYYY-MM-DD"), sourceComment },
            { propertyName: "Age", overriddenValue: null, isComputed: true, sourceComment },
            { propertyName: "YearOfConstruction", overriddenValue: null, isComputed: true, sourceComment }
        ]
    }

    getOverriddenValuesForFlag(propertyName: string, overriddenValue: any, sourceComment: string) {
        return [
            { propertyName: propertyName, overriddenValue: overriddenValue, sourceComment }
        ]
    }

    public getDisplayValue(property: MdrProperty): string {
        if (property.displayProperty && this.vessel) {
            const displayProperty = StringUtilities.camelize(property.displayProperty);
            if (this.vessel[displayProperty] != undefined || this.vessel[displayProperty] != null) {
                if (property.dataType == DataType.Boolean) {
                    return this.vessel[displayProperty] == true || this.vessel[displayProperty] == 1 ? "Yes" : "No";
                } else if (property.dataType == DataType.Double) {
                    return Number(this.vessel[displayProperty]).toFixed(property.decimalPlaces || 2);
                } else if (property.dataType == DataType.Date || property.dataType == DataType.DateTime) {
                    return moment(this.vessel[displayProperty]).format(property.dataType == DataType.Date ? this.configService.config.common.defaultDateFormat : this.configService.config.common.defaultDateTimeFormat);
                } else {
                    return this.vessel[displayProperty];
                }
            }
            return property.fallbackValue;
        }
        return null;
    }

    public compSafetyScore: CompSafetyScore;

    @computedFrom("compSafetyScore", "compSafetyScore.daysRemaining", "vessel", "vessel.age", "vessel.dwt")
    public get rsInspectionRequired() {
        return ((this.compSafetyScore && (this.compSafetyScore.daysRemaining == null || this.compSafetyScore.daysRemaining > 0)) && ((this.vessel.age > 14 && this.vessel.dwt > 8000) ||
            this.vessel.age > 25))
    }

    reportIssue() {
        this.dialogService.show(RightShipDialogServiceConstants.URLs.ReportADataIssueDialog, this.vessel, true, false, false, "right");
    }

    downloadExcel() {
        if (!this.canExportVesselDetails)
            return;

        this.manageVesselService.downloadVesselDetailsAsExcel(this.vessel.vesselId);
    }
}